import moment from "moment";
import React from "react"
import { Link } from "react-router-dom"

const SrNo = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}


const UserName = (cell) => {
  return cell.value ? cell.value : ""
};

const File = cell => {
  return cell.value ? cell.value : ""
}

const UploadDate = cell => {
  return cell.value ? moment(cell.value).format("DD/MM/YYYY")  : ""
}


export { SrNo, UserName, File, UploadDate }